import * as React from 'react'
import styled from 'styled-components'
import { renderRichtext } from '../../lib/utils/renderRichtext'
import { containerHeadline } from '../../lib/styles/Container'
import { sbEditable } from '@storyblok/storyblok-editable'

const Wrapper = styled.div`
  ${containerHeadline}
  margin: 3rem auto;
`

export const TextBox = ({ blok }) => {
  return (
    <Wrapper className="prose" {...sbEditable(blok)}>
      {renderRichtext(blok.Text)}
    </Wrapper>
  )
}
